<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>
    {{ 'general.filters' | translate }}
  </div>
  <p>{{ 'general.filterInfo' | translate }}</p>
  <h4>{{ 'users.title' | translate }}</h4>
  <ion-item lines="none">
    <ion-select aria-label=""
      label-placement="stacked"
      class="tw:w-full"
      [value]="selected()"
      [placeholder]="'general.select' | translate"
      interface="popover"
      (ionChange)="onUser($event)">
      @for (user of users(); track user.guid) {
        <ion-select-option [value]="user">
          {{ user.name }}
        </ion-select-option>
      }
    </ion-select>
  </ion-item>
  @if ((premiumPartners()?.length ?? 0) > 0) {
    <h4>{{ 'live.premiumPartner' | translate }}</h4>
    <ion-item lines="none">
      <ion-select aria-label=""
        label-placement="stacked"
        class="tw:w-full"
        [value]="selectedPremium()"
        [placeholder]="'general.select' | translate"
        interface="popover"
        (ionChange)="onPremuim($event)">
        @for (user of premiumPartners(); track user.guid) {
          <ion-select-option [value]="user">
            {{ user.name }}
          </ion-select-option>
        }
      </ion-select>
    </ion-item>
  }
</app-main-dialog>
